import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { departmentsStateClass } from "./interfaces/departmentsStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: departmentsStateClass = {
    isLoading: true,
    departmentsList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'DepartmentName',
    search: '',
    pageNo: 1,
    pageSize: 10
};

interface IThunkApi {
    state: {
        departments: departmentsStateClass
    }
};

export const getAccountDepartmentsAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "departments/v2/getAccountDepartments",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Departments', 'Get', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )
export const getAccountdepartmentsByAccountDepartmentsIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "departments/v2/getAccountDepartmentsByAccountDepartmentsId",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Departments/' + arg, 'Get', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )
export const addAccountDepartmentsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "departments/v2/addAccountDepartments",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Departments/', 'post', arg, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )
export const updateAccountDepartmentsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "departments/v2/updateAccountDepartments",
        async (arg, thunkpi) => {
            const { AccountDepartmentId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/Departments/' + AccountDepartmentId, 'POST', argWithoutId, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountDepartmentsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "departments/v2/deleteAccountDepartments",
        async (arg, thunkApi) => {

            const response = await fetchAPI('api/v2/Departments/' + arg, 'Delete', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )
export const deleteSelectedAccountDepartmentsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "departments/DeleteSelectedAccountDepartments",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Departments/DeleteAllSelectedRecordDepartment/', 'Delete', arg, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;

        }
    )


export const departmentsSlice = createSlice({
    name: 'departments',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.departmentsList.findIndex((item) => item.AccountDepartmentId == action.payload);
            const newArray = [...state.departmentsList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.departmentsList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.departmentsList.findIndex((item) => item.AccountDepartmentId == action.payload);
            const newArray = [...state.departmentsList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.departmentsList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.departmentsList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.departmentsList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.departmentsList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.departmentsList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.departmentsList;
            state.departmentsList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getAccountDepartmentsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountDepartmentsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload).length === 0) {
                    state.departmentsList = [];
                } else {
                    state.departmentsList = payload.Data;
                    state.departmentsList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountDepartmentsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountdepartmentsByAccountDepartmentsIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountdepartmentsByAccountDepartmentsIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.selectedRecord = payload.Data[0];
            })
            .addCase(getAccountdepartmentsByAccountDepartmentsIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAccountDepartmentsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountDepartmentsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountDepartmentsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountDepartmentsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountDepartmentsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountDepartmentsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAccountDepartmentsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountDepartmentsAsync.fulfilled, (state, { payload }) => {

                state.status = 'loading';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountDepartmentsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteSelectedAccountDepartmentsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteSelectedAccountDepartmentsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteSelectedAccountDepartmentsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
});


export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState, updateSorting, updatePagination } = departmentsSlice.actions
export const departmentState = (state: RootState) => state.departments
export default departmentsSlice.reducer